<span (click)="handleClick($event)"

      class="text-[12px] {{this.styleByState()}} border-1 px-2 py-1 rounded-full inline-flex items-center cursor-pointer">
  <div class="mr-1.25">{{ done() }}/{{ total() }}</div>
  <div>
    @if (expanded()) {
      <elcia-icon [iconSize]="'xs'" [iconType]="'collapse'"/>
    } @else {
      <elcia-icon [iconSize]="'xs'" [iconType]="'expand'"/>
    }
  </div>
</span>
